// Google Play Billing for the Play-installed (TWA) app, via the Digital Goods API.
// Purchases are verified and credited server-side by /.netlify/functions/play-purchase.
import { PING_PACKS } from "./oscarData";
const PLAY = "https://play.google.com/billing";

export const playAvailable = () => typeof window !== "undefined" && "getDigitalGoodsService" in window && "PaymentRequest" in window;

let svcP = null;
const service = () => (svcP = svcP || window.getDigitalGoodsService(PLAY));

export async function loadLocalPrices() {
  try {
    if (!playAvailable()) return {};
    const svc = await service();
    const det = await svc.getDetails(PING_PACKS.map(p => p.sku));
    const out = {};
    det.forEach(d => { try { out[d.itemId] = new Intl.NumberFormat(undefined, { style: "currency", currency: d.price.currency }).format(Number(d.price.value)); } catch (e) {} });
    return out;
  } catch (e) { return {}; }
}

async function verify(token, productId, purchaseToken) {
  const r = await fetch("/.netlify/functions/play-purchase", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token, productId, purchaseToken }) });
  let d = {}; try { d = await r.json(); } catch (e) {}
  if (!r.ok || !d.ok) throw new Error(d.error || "Purchase could not be verified (" + r.status + ")");
  return d;
}

// Returns {pings, balance}. Throws Error with .code === "cancelled" when user backs out.
export async function buyPack(sku, accessToken) {
  if (!playAvailable()) { const e = new Error("Purchases are available in the Oscar Radar app from Google Play."); e.code = "unavailable"; throw e; }
  const req = new PaymentRequest([{ supportedMethods: PLAY, data: { sku } }], { total: { label: "Total", amount: { currency: "USD", value: "0" } } });
  let resp;
  try { resp = await req.show(); } catch (err) { const e = new Error("Purchase cancelled"); e.code = "cancelled"; throw e; }
  try {
    const d = await verify(accessToken, sku, resp.details.purchaseToken);
    await resp.complete("success");
    return d;
  } catch (err) { try { await resp.complete("fail"); } catch (e) {} throw err; }
}

// Re-submit any purchase Play still lists as owned (idempotent server-side).
export async function recoverPurchases(accessToken) {
  try {
    if (!playAvailable() || !accessToken) return null;
    const svc = await service();
    const list = await svc.listPurchases();
    let last = null;
    for (const p of list) { try { last = await verify(accessToken, p.itemId, p.purchaseToken); } catch (e) {} }
    return last;
  } catch (e) { return null; }
}
